import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserRole } from '../types/types';
import { isMarketingAdminRole } from '../roles/portalRoles';

const MarketingAdminRouteGuard = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const roleId = localStorage.getItem('user_role_id');
    const userId = localStorage.getItem('user_id');
    const userRole = roleId ? (parseInt(roleId, 10) as UserRole) : null;

    if (!isMarketingAdminRole(userRole) || !userId) {
      return;
    }

    const path = location.pathname;
    const profilePath = `/users/${userId}`;
    const allowedPaths = [profilePath, '/not-authorized'];

    const isAllowed = allowedPaths.some(
      (allowedPath) => path === allowedPath || path.startsWith(`${profilePath}/`)
    );

    if (isAllowed) {
      return;
    }

    if (path === '/' || path === '') {
      navigate(profilePath, { replace: true });
      return;
    }

    navigate('/not-authorized', { replace: true });
  }, [location.pathname, navigate]);

  return <>{children}</>;
};

export default MarketingAdminRouteGuard;
